import styled from 'styled-components';

export const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px 0px 0px 0px;
  margin-bottom:
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 15px 0px;
  cursor:pointer;
  border: 2px dashed #17BFDD;
  justify-content: center;
  align-items: center;
`;

export const FileUploadContainer = styled.div`
  display: flex;
  flex-direction: column;
  font-family:"Avenir Next LT W01 Demi";
  justify-content: center;
  align-items: center;
  cursor:pointer;
`;

export const UploadImage = styled.img`
  margin: 10px 0;
`;

export const SmallTitle = styled.div`
  font-family: 'Avenir Next LT W01 Demi';
  font-size: 14px;
  font-weight: normal;
  align-items: center;
  text-align: left;
  margin-bottom: 5px;
`;

export const OptionsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

export const Option = styled.img`
  width: 35px;
  margin: 5px 5px;
  cursor:pointer;
`;

export const UploadInProgressContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 10px;
`;
